import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './DropdownSelector.module.scss';
import ICONS from '../../static/media/icons/icons-helper';
import useOutsideClick from '../../utils/hooks/useOutsideClick';

const DropdownSelector = ({
  listData,
  onSelected,
  isThemeLight,
  fontStyle,
  inputBorderStyle,
}) => {
  const [selectedItem, setSelectedItem] = useState('Choose your state');
  const [isSelecting, setIsSelecting] = useState(false);
  const [parentContainerWidth, setParentContainerWidth] = useState(0);
  const selectorRef = useRef(null);

  useOutsideClick(selectorRef, () => setIsSelecting(false));

  useEffect(() => {
    setParentContainerWidth(selectorRef.current?.offsetWidth || '90%');
  }, [selectorRef]);

  const handleOnClickDropdown = () => {
    setIsSelecting((value) => !value);
  };

  const handleSelectItem = (value) => {
    setSelectedItem(value);
    setIsSelecting(false);
    onSelected(value);
  };

  const handleResetFilter = () => {
    setSelectedItem('Choose your state');
    onSelected('');
    setIsSelecting(false);
  };

  const containerClasses = classnames(
    styles.container,
    isThemeLight ? styles.lightContainer : null,
    inputBorderStyle
  );

  const selectedItemTextClasses = classnames(
    styles.selectedItemText,
    isThemeLight ? styles.lightSelectedItemText : null,
    styles[`${fontStyle}SelectedItemText`]
  );

  const dropdownContainerClasses = classnames(
    styles.dropdownContainer,
    isThemeLight ? styles.lightDropdownContainer : null
  );

  return (
    <div ref={selectorRef}>
      <div className={containerClasses} onClick={handleOnClickDropdown}>
        <p className={selectedItemTextClasses}>{selectedItem.toUpperCase()}</p>
        <img
          className={styles.arrowIcon}
          src={isThemeLight ? ICONS.DARK_CHEVRON_LEFT : ICONS.CHEVRON_LEFT}
          alt="logo-img"
        />
      </div>
      {isSelecting && (
        <div
          className={dropdownContainerClasses}
          style={{ width: parentContainerWidth }}
        >
          <p className={selectedItemTextClasses} onClick={handleResetFilter}>
            ALL
          </p>
          {listData &&
            listData.map((item) => (
              <p
                key={item}
                className={selectedItemTextClasses}
                onClick={() => handleSelectItem(item)}
              >
                {item}
              </p>
            ))}
        </div>
      )}
    </div>
  );
};

DropdownSelector.propTypes = {
  listData: PropTypes.arrayOf(Array).isRequired,
  onSelected: PropTypes.func.isRequired,
  isThemeLight: PropTypes.bool,
  fontStyle: PropTypes.oneOf(['thin', 'bold']),
  inputBorderStyle: PropTypes.string,
};

DropdownSelector.defaultProps = {
  isThemeLight: false,
  fontStyle: 'bold',
  inputBorderStyle: null,
};

export default DropdownSelector;
